<div class="booking-create container">
  <button class="button button--white button--small hide--sm"
          [disabled]="photographerSlug === null"
          [routerLink]="['/', photographerSlug]"
  >
    <i class="fa-solid fa-arrow-left"></i>
    {{'marketplace.booking.create.back'|transloco}}
  </button>


  <button class="booking-create__back button button--light-grey button--circle button--square hide--md hide--lg"
          [disabled]="photographerSlug === null"
          [routerLink]="['/', photographerSlug]">
    <i class="fa-solid fa-arrow-left"></i>
  </button>
  <app-inline-carousel
    class="booking-create__carousel hide--md hide--lg"
    [photos]="getGalleryPhotos()"
    [openFullScreenPhotoOnClick]="false"
  ></app-inline-carousel>

  <div class="booking-create-container">
    @if (!service) {
      <div class="service" >
        <div class="service__main-image skeleton-loading hide--sm"></div>
        <div class="service__title skeleton-loading"></div>
        <div class="service__price skeleton-loading"></div>
        <div class="service__description skeleton-loading"></div>
      </div>
    }

    @if (service) {
      <div class="service">
        @if (getMainImage()) {
          <div class="service__main-image hide--sm">
            <app-image
              [src]="getMainImage()!"
              [alt]="service.name"
              preset="card"
              aspectRatio="1"
              [sizes]="'320px'"
              [width]="320"
              [height]="320"
            ></app-image>
          </div>
        }
        <h1 class="service__title">{{service.name}}</h1>
        @if (service.priceRangeActive) {
          @if (service.discountActive) {
            <p class="service__price">
              {{'service.pricing.starting-at'|transloco}}
              <span class="old">{{service.priceRangeMinPublic|currency:'EUR'}}</span>
              <span class="new">{{((service.priceRangeMinPublic ?? 0) * (1 - (service.discount ?? 0)/100))|currency:'EUR'}}</span>
            </p>
          } @else {
            <p class="service__price">{{'service.pricing.starting-at'|transloco}} {{service.priceRangeMinPublic|currency:'EUR'}}</p>
          }
        } @else {
          @if (service.discountActive) {
            <p class="service__price">
              <span class="old">{{service.publicPrice|currency:'EUR'}}</span>
              <span class="new">{{((service.publicPrice) * (1 - (service.discount ?? 0)/100))|currency:'EUR'}}</span>
            </p>
          } @else {
            <p class="service__price">{{service.publicPrice|currency:'EUR'}}</p>
          }
        }

        @if (service.duration | formatDuration) {
          <div class="service__tags">
            <span class="tag">
              <i class="fa-regular fa-clock"></i>
              {{ service.duration | formatDuration }}
            </span>
          </div>
        }

        <p class="service__description"
          [innerHTML]="getFormattedServiceDescription(service)"
        ></p>
      </div>
    }

    <div class="booking">
      @if (service?.photos?.length) {
        <section class="sf-section booking__service-carousel hide--sm">
          <div class="sf-section__header">
            <h2 class="sf-section__title">{{'marketplace.booking.create.photos.title'|transloco}}</h2>
          </div>
          <p class="sf-section__subtitle">{{'marketplace.booking.create.photos.subtitle'|transloco}}</p>
          <app-inline-carousel [photos]="getGalleryPhotos()"></app-inline-carousel>
        </section>
      }

      <section class="sf-section sf-section--with-button">
        <div class="sf-section__header">
          <h2 class="booking__title">{{'marketplace.booking.create.select-date-form.title'|transloco}}</h2>
        </div>
        <p class="sf-section__subtitle">{{'marketplace.booking.create.select-date-form.subtitle'|transloco}}</p>
        <form class="booking__form"
              [formGroup]="bookingForm"
              (ngSubmit)="onBookNow()"
              #bookingFormEl
        >
          <div class="input-group" [ngClass]="{ 'input-group--error': isDateOrTimeInvalid() }">
            <label>{{ 'marketplace.booking.create.select-date-form.select-a-date.label' | transloco }}</label>
            <app-date-time-picker
              [serviceId]="service?.id ?? null"
              [locale]="activeLocale"
              (dateSelected)="onDateSelected($event)"
              (selectionChange)="onDateTimeSelected($event)"
            ></app-date-time-picker>
            <input type="hidden" formControlName="date" />
            <input type="hidden" formControlName="hour" />
            <input type="hidden" formControlName="minute" />
            @if (isControlInvalid('date') && bookingForm.get('date')?.errors?.['required']) {
              <div class="input-group__error-message">
                {{ 'marketplace.booking.create.select-date-form.select-a-date.errors.required' | transloco }}
              </div>
            }
            @if (isControlInvalid('date') && bookingForm.get('date')?.errors?.['notInFuture']) {
              <div class="input-group__error-message">
                {{ 'marketplace.booking.create.select-date-form.select-a-date.errors.future' | transloco }}
              </div>
            }
            @if (isControlInvalid('date') && !bookingForm.get('date')?.errors?.['required'] && !bookingForm.get('date')?.errors?.['notInFuture']) {
              <div class="input-group__error-message">
                {{ 'marketplace.booking.create.select-date-form.select-a-date.errors.invalid' | transloco }}
              </div>
            }
            @if (isTimeInvalid()) {
              <div class="input-group__error-message">
                {{ 'marketplace.booking.create.select-date-form.select-a-date.time.error' | transloco }}
              </div>
            }
          </div>

          @if (service && service.priceRangeActive) {
            <app-helper-banner>
              <div helper-content>
                <p>{{ 'marketplace.booking.create.price-range.help' | transloco: {'min': ((service.priceRangeMinPublic ?? 0) * (1 - (service.discount ?? 0) / 100)), 'max': ((service.priceRangeMaxPublic ?? 0) * (1 - (service.discount ?? 0) / 100))} }}</p>
              </div>
            </app-helper-banner>

            <div class="input-group" [ngClass]="{ 'input-group--error': shouldShowPriceErrors() }">
              <label>{{ 'marketplace.booking.create.price-range.label' | transloco }}</label>
              <input type="number"
                     step="0.01"
                     min="{{((service.priceRangeMinPublic ?? 0) * (1 - (service.discount ?? 0) / 100))}}"
                     max="{{((service.priceRangeMaxPublic ?? 0) * (1 - (service.discount ?? 0) / 100))}}"
                     formControlName="price"
                     placeholder="{{ 'marketplace.booking.create.price-range.placeholder' | transloco }}"
              />
              @if ((service && service.priceRangeMinPublic && bookingForm.value.price < ((service.priceRangeMinPublic) * (1 - (service.discount ?? 0) / 100))) && shouldShowPriceErrors()) {
                <p class="input-group__error-message">{{'marketplace.booking.create.price-range.error.too-low' | transloco}}</p>
              }
              @if ((service && service.priceRangeMaxPublic && bookingForm.value.price > ((service.priceRangeMaxPublic) * (1 - (service.discount ?? 0) / 100))) && shouldShowPriceErrors()) {
                <p class="input-group__error-message">{{'marketplace.booking.create.price-range.error.too-high' | transloco}}</p>
              }
              @if ((bookingForm.value.price === null || bookingForm.value.price === '') && shouldShowPriceErrors()) {
                <p class="input-group__error-message">{{'marketplace.booking.create.price-range.error.empty' | transloco}}</p>
              }
            </div>
          }

          <div class="input-group--side-by-side">
            <div class="input-group" [ngClass]="{ 'input-group--error': isControlInvalid('firstname') }">
              <label>{{ 'register.firstname.label' | transloco }}</label>
              <input
                type="text"
                formControlName="firstname"
                placeholder="{{ 'register.firstname.placeholder' | transloco }}" />
              @if (isControlInvalid('firstname')) {
                <div class="input-group__error-message">
                  {{ 'marketplace.booking.create.select-date-form.firstname.errors.required' | transloco }}
                </div>
              }
            </div>
            <div class="input-group" [ngClass]="{ 'input-group--error': isControlInvalid('lastname') }">
              <label>{{ 'register.lastname.label' | transloco }}</label>
              <input
                type="text"
                formControlName="lastname"
                placeholder="{{ 'register.lastname.placeholder' | transloco }}" />
              @if (isControlInvalid('lastname')) {
                <div class="input-group__error-message">
                  {{ 'marketplace.booking.create.select-date-form.lastname.errors.required' | transloco }}
                </div>
              }
            </div>
          </div>

          <div class="input-group" [ngClass]="{ 'input-group--error': isControlInvalid('note') }">
            <label>{{ 'marketplace.booking.create.select-date-form.note.label' | transloco }}</label>
            <textarea
              formControlName="note"
              [placeholder]="'marketplace.booking.create.select-date-form.note.placeholder' | transloco"
            ></textarea>
            @if (isControlInvalid('note')) {
              <div class="input-group__error-message">
                {{ 'marketplace.booking.create.select-date-form.note.errors.required' | transloco }}
              </div>
            }
          </div>

          @if (!user) {
            <div class="input-group" [ngClass]="{ 'input-group--error': isControlInvalid('email') }">
              <label>{{ 'marketplace.booking.create.select-date-form.email.label' | transloco }}</label>
              <input type="email" formControlName="email" />
              @if (isControlInvalid('email') && bookingForm.get('email')?.errors?.['required']) {
                <div class="input-group__error-message">
                  {{ 'marketplace.booking.create.select-date-form.email.errors.required' | transloco }}
                </div>
              }
              @if (isControlInvalid('email') && bookingForm.get('email')?.errors && !bookingForm.get('email')?.errors?.['required']) {
                <div class="input-group__error-message">
                  {{ 'marketplace.booking.create.select-date-form.email.errors.invalid' | transloco }}
                </div>
              }
            </div>
          }

          @if (service && canPayDeposit()) {
            <div class="input-group">
              <label>{{ 'marketplace.booking.create.payment.label' | transloco }}</label>
              <app-segmented-control
                [options]="paymentOptions"
                [value]="bookingForm.value.paymentMode"
                (valueChange)="onPaymentModeChange($event)"
              ></app-segmented-control>
            </div>
          }

          <div class="input-group booking-create__terms" [ngClass]="{ 'input-group--error': isControlInvalid('termsAccepted') }">
            <label for="termsAccepted">
              <input type="checkbox" id="termsAccepted" formControlName="termsAccepted" />
              <span [innerHTML]="'marketplace.booking.create.select-date-form.terms.label' | transloco"></span>
            </label>
            @if (isControlInvalid('termsAccepted')) {
              <div class="input-group__error-message">
                {{ 'marketplace.booking.create.select-date-form.terms.error' | transloco }}
              </div>
            }
          </div>

          <div class="booking-create__book-now-container">
            @if (service && service.discountActive) {
              <div class="booking-create__book-now-container-discount">
                <i class="fa-solid fa-tag booking-create__discount-icon"></i>
                <p>{{ 'marketplace.booking.create.select-date-form.discount' | transloco:{ discount: service.discount} }}</p>
              </div>
            }

            <button
              type="submit"
              class="button button--primary button--large button--full-width"
              [disabled]="submitting"
            >
              {{ 'marketplace.booking.create.select-date-form.confirm.label' | transloco }}
              <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </form>
      </section>

    </div>
  </div>
</div>
